import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react'
import { TurnstileWidget } from './TurnstileWidget'

export type TurnstileGateHandle = {
  reset: () => void // 토큰 비우고 다시 표시 + 위젯 reset
  show: () => void // 강제로 표시
  hide: () => void // 강제로 숨김
  getToken: () => string | null
}

type Props = {
  action: 'login' | 'signup' | 'forgot'
  onTokenChange?: (token: string | null) => void
  autoHideOnSuccess?: boolean // 기본 true
  helperText?: string // 기본 안내문
}

const TurnstileGate = forwardRef<TurnstileGateHandle, Props>(
  (
    {
      action,
      onTokenChange,
      autoHideOnSuccess = true,
      helperText = '봇 방지 체크를 완료해 주세요.'
    },
    ref
  ) => {
    const [token, setToken] = useState('')
    const [hidden, setHidden] = useState(false)
    const [resetKey, setResetKey] = useState(0)

    // 토큰 변경 → 외부로 전달 + 자동 숨김
    useEffect(() => {
      const t = token || null
      onTokenChange?.(t)

      if (autoHideOnSuccess) {
        setHidden(Boolean(token))
      }
    }, [token, onTokenChange, autoHideOnSuccess])

    const api = useMemo<TurnstileGateHandle>(
      () => ({
        reset: () => {
          setToken('')
          setHidden(false)
          setResetKey((v) => v + 1)
        },
        show: () => setHidden(false),
        hide: () => setHidden(true),
        getToken: () => (token ? token : null)
      }),
      [token]
    )

    useImperativeHandle(ref, () => api, [api])

    return (
      <div className="w-full">
        {!hidden && <div className="text-xs text-gray-500 mb-2">{helperText}</div>}
        <TurnstileWidget
          siteKey={import.meta.env.VITE_TURNSTILE_SITE_KEY}
          action={action}
          size="flexible"
          hidden={hidden}
          resetKey={resetKey}
          onToken={(t) => setToken(t)}
        />
      </div>
    )
  }
)

export default TurnstileGate
